module.exports = __webpack_public_path__ + "media/customizations/crosscreek/logo-408415957feabe68cfa1da5d5d95cab1.png";